import React from 'react'
import './HeaderSolutionsMenu.scss'

class HeaderSolutionsMenu extends React.Component {
  render() {
    return (
      <div className="header-solutions-menu">
        <div className="solutions-menu-content">
          <div className="menu-section">
            <h3 className="section-title">Services</h3>
            <ul className="menu-items">
              <li>
                <a href="/devsecops">DevSecOps</a>
              </li>
              <li>
                <a href="/ai">AI</a>
              </li>
              <li>
                <a href="/cybersecurity">Cybersecurity</a>
              </li>
              <li>
                <a href="/software-development">Software Development</a>
              </li>
              <li>
                <a href="/it-operations">IT Operations</a>
              </li>
            </ul>
          </div>

          <div className="menu-section">
            <h3 className="section-title">Solutions</h3>
            <ul className="menu-items">
              <li>
                <a href="/reaper">REAPER: AI Decision Advantage</a>
              </li>
              <li>
                <a href="/code-falcon">Code Falcon: Secure Development</a>
              </li>
              <li>
                <a href="/bifrost">Bifrost: Hardened CI/CD</a>
              </li>
              <li>
                <a href="/covalent">Enclave AI: Data Platform</a>
              </li>
              <li>
                <a href="/kubernetes">Kubernetes</a>
              </li>
              <li>
                <a href="/boost">Boost: Product Accelerator</a>
              </li>
            </ul>
          </div>

          <div className="menu-section">
            <h3 className="section-title">Mission Technologies</h3>
            <ul className="menu-items">
              <li>
                <a href="/command-control">Command and Control</a>
              </li>
              <li>
                <a href="/logistics">Logistics</a>
              </li>
              <li>
                <a href="/health-it">Health IT</a>
              </li>
            </ul>
          </div>
        </div>
      </div>
    )
  }
}

export default HeaderSolutionsMenu
